import { initContract } from "@ts-rest/core";

const c = initContract();

export { c };
